export default __webpack_public_path__ + "static/media/bg-hero.c5a6fd17.webp";